import React, { useState } from 'react'
import { Url } from '../../UrlServer'
import { FiPlusCircle, FiMinusCircle } from 'react-icons/fi'
import { BsTrash } from 'react-icons/bs'
import { CartItem as TCartItem } from '../../../redux/reducers/cartReducer'
import { formatUSD } from '../../../utils/formatter'

interface CartItemProps {
  item?: TCartItem
  handleRemoveCart: (id: string) => void
  modifyQuantity: (itemID: string, type: 'add' | 'sub') => void
}

const CartItem: React.FC<CartItemProps> = ({
  item,
  handleRemoveCart,
  modifyQuantity
}) => {
  const [qty, setQty] = useState(item?.quantity || 0)

  const decQty = () => {
    qty === 1 ? setQty(1) : setQty(qty - 1)
    modifyQuantity(item?._id || '', 'sub')
  }

  const incQty = () => {
    qty === 10 ? setQty(10) : setQty(qty + 1)
    modifyQuantity(item?._id || '', 'add')
  }
  return (
    <tr key={item?._id + '' + Math.random() + new Date().getTime().toString()}>
      <td className="cart__v1 trash">
        <BsTrash
          className="trash-control"
          onClick={() => handleRemoveCart(item?._id || '')}
        />
      </td>
      <td className="cart__v2">
        <div className="img-wraper">
          <img
            src={`${Url}/${item?.product?.image || ''}`}
            alt={item?.product?.image || ''}
          />
        </div>
        <p>
          <span className="v2--show-mobile">Pr-Name: </span>
          {item?.product?.name || ''}
        </p>
      </td>
      <td className="cart__v3">
        <div className="v3--single price">
          <span className="v3-mobile">Price:</span>
          <div>{formatUSD(item?.product?.price || 0)}</div>
        </div>
        <div className="v3--single quantity ">
          <span className="v3-mobile">Quantity:</span>
          <div className="qty-set">
            <button
              className="middle-check"
              disabled={qty === 1}
              onClick={decQty}
            >
              <FiMinusCircle className="quantity-control" />
            </button>
            {qty}
            <button
              className="middle-check"
              disabled={qty === 10}
              onClick={incQty}
            >
              <FiPlusCircle className="quantity-control" />
            </button>
          </div>
        </div>
        <div className="v3--single subtotal">
          <span className="v3-mobile">Subtotal:</span>
          <div>{formatUSD((item?.product?.price || 0) * qty)}</div>
        </div>
      </td>
    </tr>
  )
}

export default CartItem
